module.exports = __webpack_public_path__ + "img/tetramoera-schistaceana.6b55e102.jpg";